import { useEffect, useState } from 'react';
import { TreeSelect } from 'antd';
const { SHOW_PARENT } = TreeSelect;

export const MultiSelect = ({ title = '', options, width, onChange }) => {
  const [value, setValue] = useState([]);
  const onHandleChange = (newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (onChange) onChange(value);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const treeProps = {
    treeData: options?.map((option) => { return { label: `${option.label}${option?.desc ? ` ${option.desc}` : ''}`, value : option.value } }),
    value,
    onChange: onHandleChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 0,
    maxTagPlaceholder: `${title} 선택`,
    // tagRender: () => {
    //   return '';
    // },
    placeholder: `${title}`,
    style: {
      width: width || '100%',
    },
  };
  return <TreeSelect {...treeProps} />;
};